@if (largetitle !== 'true') {
<h4 [ngClass]="animate" (animationend)="animate['fade-animation'] = false" [id]="titleIdentifier">
  {{ title }}
</h4>
} @if (largetitle === 'true') {
<h2 [ngClass]="animate" (animationend)="animate['fade-animation'] = false" [id]="titleIdentifier">
  {{ title }}
</h2>
}
<ng-content></ng-content>
